/* global google, define, SmartInfoWindow, window, document, clearInterval, setInterval, setTimeout, Image */

define('views/PropertyView',[
    'jquery',
    'underscore',
    'backbone',
    'text!templates/views/PropertyWindow.html'
], function($, _, Backbone, propertyWindowTemplate) {

    'use strict';

    var Control = Backbone.View.extend({

        event: {},
        initialize: function() {

            // Bind All
            _.bindAll(this);

            this.index = 0;

            var patt = /[0-9]+/g,
                url = this.options.form_controller_url,
                result = patt.exec(url);

            if (!result && result.length === 0) {
                return;
            }

            this.accountId = result[0];

            var _this = this;

            $(document).keyup(function(e) {

                if (e.keyCode === 27) {
                    _this.close();
                }
            });

            this.map = this.options.map;

        },
        render: function() {

            if (this.wnd) {
                this.wnd.onRemove();
                this.wnd = null;
            }

            var markers = this.options.markers;

            if (this.index < 0) {
                this.index = markers.length - 1;
            } else if (this.index > markers.length - 1) {
                this.index = 0;
            }

            var property = markers[this.index].property,
                addressLine = '';

            this.property = property;

            if (property.UNIT_NUMBER && $.trim(property.UNIT_NUMBER).length > 0) {
                addressLine += property.UNIT_NUMBER + '-';
                addressLine += property.STREET_NUMBER + ' ';
            } else {
                addressLine += property.STREET_NUMBER + ' ';
            }

            addressLine += property.STREET_NAME + ' ';
            addressLine += property.STREET_TYPE + ' ';
            addressLine += property.STREET_DIR + '<br>';
            addressLine += property.CITY + ' ';

            property.ADDRESS_LINE = addressLine;

            property.PROPERTY_IMG_URL = 'http://' + this.options.resource_server + '/wps/rest/' +
                '0/l/' + property.LIST_ID + '/image/first?w=150';

            var $content = $(_.template(propertyWindowTemplate, {
                property: property
            }));

            this.$content = $content;
            this.windowOptions = {};

            if (markers && markers.length > 1) {
                $content.find('.navigation').show();
                $content.find('.navLocation').text((this.index + 1) + ' of ' + markers.length);
                this.windowOptions.height = 330;

            } else {
                $content.find('.navigation').hide();
                this.windowOptions.height = 310;
            }

            $content.find('.close').on('click', this.close);
            $content.find('.navLeft').on('click', this.left);
            $content.find('.navRight').on('click', this.right);
            $content.find('.listingDetails').on('click', this.showDetails);

            this.windowOptions.mapPosition = {
                x: this.options.offsetLeft,
                y: this.options.offsetTop
            };
            this.windowOptions.position = this.options.markers[0].getPosition();
            this.windowOptions.map = this.options.map;
            this.windowOptions.content = $content.get(0);
            this.windowOptions.width = 165;

            this.wnd = new SmartInfoWindow(this.windowOptions);
            this.getAttribution();
            this.getRibbon();
        },
        open: function() {
            this.render();
            this.startPulse();
        },
        close: function() {
            this.wnd.onRemove();
            this.stopPulse();
        },
        right: function() {
            this.index++;
            this.render();
        },
        left: function() {
            this.index--;
            this.render();
        },
        showDetails: function() {

            var opts = 'width=900,height=600,scrollbars=yes,resizable=yes,status=no,location=no,toolbar=no,menubar=no,directories=no',
                url = this.options.form_controller_url,
                idx = url.lastIndexOf('/');

            if (idx !== -1) {
                url = url.substring(0, idx);
            }

            url += '/browse/ListingDetails.form?noframe=true&listingId=' + this.property.LIST_ID;

            window.open(url, 'details' + this.property.LIST_ID, opts);

            /*

            try{
            if( typeof $wnd.publishToBus == 'function' ) {
            $wnd.publishToBus( 'gmap.details', { 'url': url, 'listingId': this.property.LIST_ID }, false );
            }
            else {
            window.open( url, 'details' + this.property.LIST_ID, opts );
            }
            }
            catch( e ){
            window.open( url, 'details' + this.property.LIST_ID, opts );
            }*/

        },
        getRibbon: function() {

            var $content = this.$content,
                $img = this.$content.find('.listingImage'),
                $div = $('<div class="listingImageBanner"></div>'),
                url = '/wps/rest/' + this.accountId + '/l/' + this.property.LIST_ID + '/img/ribbon/auto?ts=' + new Date();

            var image = new Image();
            image.onload = function() {
                $div.css('top', $img.position().top + 'px');
                $div.css('left', $img.position().left + 'px');
                $div.css('background', 'url(\'' + image.src + '\') no-repeat');
                $div.width($img.width());
                $div.height($img.height() - 10);
            };

            image.src = url;

            $content.find('.listingImageBanner').remove();

            $content.find('.body').append($div);
            $div.on('click', this.showDetails);
        },
        getAttribution: function() {

            var $content = this.$content,
                url = null;

            if (window.parent.attributionURLPrefix &&
                window.parent.attributionURLPrefix.indexOf('localost') !== -1) {
                url = window.parent.attributionURLPrefix + this.property.LIST_ID + '/attribution';
            } else {
                url = '/wps/rest/' + this.accountId + '/l/recip/' + this.property.LIST_ID + '/attribution';
            }

            $.ajax({
                type: 'GET',
                url: url,
                async: true,
                dataType: 'text',
                success: function(text) {

                    text = $.trim(text);
                    text = text.replace(/\n/g, ' ');
                    text = text.replace(/\r/g, ' ');
                    text = text.replace(/\t/g, ' ');
                    text = text.replace(/  /g, ' ');

                    if (text.endsWith('and')) {
                        text = text.substring(0, text.length - 3);
                        text = $.trim(text);
                    }

                    var $listedBy = $content.find('.listedBy');
                    $listedBy.text(text);
                    $listedBy.attr('title', text);
                    /*$footer.tooltip({
						placement: 'bottom',
						container: 'body'
					});*/
                }
            });

        },
        stopPulse: function() {
            clearInterval(this.pulseDelayTimer);
        },
        startPulse: function() {

            var marker = this.options.markers[0],
                location = marker.getPosition();

            var outer = new google.maps.Marker({
                position: location,
                clickable: false,
                icon: {
                    path: google.maps.SymbolPath.CIRCLE,
                    fillOpacity: 0.5,
                    fillColor: '1bb6ff',
                    strokeOpacity: 1.0,
                    strokeColor: 'red',
                    strokeWeight: 1.0,
                    scale: 0,
                    zIndex: 1000

                },
                optimized: false,
                map: this.map,
                zIndex: 1000
            });

            var inner = new google.maps.Marker({
                position: location,
                clickable: false,
                icon: {
                    path: google.maps.SymbolPath.CIRCLE,
                    fillOpacity: 1.0,
                    fillColor: '61a0bf',
                    strokeWeight: 0,
                    scale: 0,
                    zIndex: 1000
                },
                optimized: false,
                zIndex: 1000
            });

            var _this = this;

            function pulse() {
                for (var i = 0; i <= 10; i++) {
                    setTimeout(_this.setScale(inner, outer, i / 10), i * 60);
                }
            }

            pulse();

            if (this.pulseDelayTimer) {
                clearInterval(this.pulseDelayTimer);
            }

            this.pulseDelayTimer = setInterval(

                function() {

                    /*var overlayView = new google.maps.OverlayView();
				overlayView.setMap(_this.map);
				var $pane = $(overlayView.getPanes().overlayImage); // Pane 3  
				$pane.append(outer);*/

                    outer.setMap(_this.map);
                    _this.setScale(inner, outer, 0);
                    pulse();
                }, 1000);

            return;
        },

        setScale: function(inner, outer, scale) {
            return function() {
                if (scale === 1) {
                    outer.setMap(null);
                } else {
                    var icono = outer.get('icon');
                    icono.strokeOpacity = Math.cos((Math.PI / 2) * scale);
                    icono.fillOpacity = icono.strokeOpacity * 0.5;
                    icono.scale = Math.sin((Math.PI / 2) * scale) * 15;
                    outer.set('icon', icono);


                    var iconi = inner.get('icon');
                    var newScale = (icono.scale < 2.0 ? 0.0 : 2.0);
                    if (iconi.scale !== newScale) {
                        iconi.scale = newScale;
                        inner.set('icon', iconi);
                        if (!inner.getMap()) {
                            inner.setMap(this.map);
                        }
                    }
                }
            };

        }

    });

    return Control;

});

